import type { JsonValue } from '@seen/core/json'
import { useEffect, useRef } from 'react'
import type { UseFormWatch } from 'react-hook-form'

/* Calls `onFieldEdit` when the clinician changes a field's value themselves.
 * react-hook-form tags a change with `type: 'change'` only when it comes from a
 * field's own onChange; `setValue` (a suggestion decision) and `reset` (a
 * prefill) emit none, so neither reads as an edit. */
export function useFieldEditListener(
  watch: UseFormWatch<any>,
  onFieldEdit:
    | ((linkId: string, value: JsonValue | undefined) => void)
    | undefined
): void {
  const onFieldEditRef = useRef(onFieldEdit)
  useEffect(() => {
    onFieldEditRef.current = onFieldEdit
  })
  useEffect(() => {
    const subscription = watch((values, { name, type }) => {
      if (type === 'change' && name) {
        onFieldEditRef.current?.(name, values[name])
      }
    })
    return () => subscription.unsubscribe()
  }, [watch])
}
